export const COOKIE_NAME = 'ruralytics'
export const COOKIE_KEY_RECOMMENDED = 'recommended'
export const COOKIE_DAYS = 5
export const MODULE_NAME = 'integrations/ruralytics'
export const NUXT_API_RURALYTICS_STATS = `${MODULE_NAME}/stats`

export const DEFAULT_REPOSITORY = {
  [COOKIE_KEY_RECOMMENDED]: [],
}
